/*
 * Copyright (c) Nexign, JSC, 2024.
 */
/**
 *
 * @author Ilya Baranchikov
 * @version 1.29.0
 * @since 1.29.0
 */

const kilo = 1024;
export const KB = kilo;

export const MB = kilo * kilo;
export const GB = kilo * kilo * kilo;
export const TB = kilo * kilo * kilo * kilo;

export enum EMultipleByteUnits {
    byte = 'byte',
    kilobyte = 'kilobyte',
    megabyte = 'megabyte',
    gigabyte = 'gigabyte',
    terabyte = 'terabyte',
}

interface IReturnValue {
    amount: number;
    units: EMultipleByteUnits;
}

export const getMultipleBytesWithUnits = (bytes: number, preferableFormat?: EMultipleByteUnits): IReturnValue => {
    if ((bytes < KB && !preferableFormat) || preferableFormat === EMultipleByteUnits.byte) {
        return {
            amount: bytes,
            units: EMultipleByteUnits.byte,
        };
    } else if ((bytes >= KB && bytes < MB && !preferableFormat) || preferableFormat === EMultipleByteUnits.kilobyte) {
        const amount = parseFloat((bytes / KB).toFixed(2));

        return {
            amount,
            units: EMultipleByteUnits.kilobyte,
        };
    } else if ((bytes >= MB && bytes < GB && !preferableFormat) || preferableFormat === EMultipleByteUnits.megabyte) {
        const amount = parseFloat((bytes / MB).toFixed(2));

        return {
            amount,
            units: EMultipleByteUnits.megabyte,
        };
    } else if ((bytes >= GB && bytes < TB && !preferableFormat) || preferableFormat === EMultipleByteUnits.gigabyte) {
        const amount = parseFloat((bytes / GB).toFixed(2));

        return {
            amount,
            units: EMultipleByteUnits.gigabyte,
        };
    }

    const amount = parseFloat((bytes / TB).toFixed(2));

    return {
        amount,
        units: EMultipleByteUnits.terabyte,
    };
};
